export default __webpack_public_path__ + "static/media/img-3.9446db4f.jpg";